import { render, staticRenderFns } from "./WhenExpiry.vue?vue&type=template&id=95c08a6c&scoped=true&lang=pug"
import script from "./WhenExpiry.vue?vue&type=script&lang=js"
export * from "./WhenExpiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c08a6c",
  null
  
)

export default component.exports